import React from 'react';
import Rapport from '../../accessibilite/rapport';

const Accessibilite = () => {
    return <Rapport />;
};

export default Accessibilite;
